import { useEffect } from 'react';

import useAppDownloadCujModal from '@/hooks/cuj/useAppDownloadCujModal';
import { HospitalPartnership } from '@/parsers/f2f/common';
import { HospitalResponse, HospitalReviewMetricResponse } from '@/types/hospital';

import useGetHospitalById from './useGetHospitalById';
import useGetTotalReviewCountWithAverageRatingByPublicId from './useGetTotalReviewCountWithAverageRatingByPublicId';

interface HospitalPageViewModel {
  hospital?: HospitalResponse;
  reviewData?: HospitalReviewMetricResponse;
  hospitalPartnership: HospitalPartnership;
}

const useHospitalPageViewModel = (hospitalPid: string): HospitalPageViewModel => {
  const { data: hospital } = useGetHospitalById(hospitalPid);
  const { data: reviewData } = useGetTotalReviewCountWithAverageRatingByPublicId(hospitalPid);
  const { setIsCujModalTrackingInfo } = useAppDownloadCujModal();

  const hospitalPartnership = new HospitalPartnership(hospital?.partnershipTemplate ?? false);

  useEffect(() => {
    if (!hospital) {
      return;
    }

    setIsCujModalTrackingInfo({
      campaignName: 'web_hospitals',
      trackContent: 'web_mid_mdl_details',
      contentId: hospitalPid,
      contentTitle: hospital.name,
    });
  }, [hospital]);
  return {
    hospital,
    hospitalPartnership,
    reviewData,
  };
};

export default useHospitalPageViewModel;
